import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { AuthService } from '@app/services/auth.service';
import { CourseService } from '@app/services/course.service';
import { LocalisationService } from '@app/services/localisation.service';
import { NavigationService } from '@app/services/navigation.service';
import { QuestionnaireService } from '@app/services/questionnaire.service';
import { Subscription } from 'rxjs';

import { LoginComponent } from './../../account/login/login.component';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainNavComponent implements OnInit, OnDestroy {
  locale: any = {};
  questionnaireComplete: boolean = false;
  courseAreasComplete: boolean = false;
  courseAreasSeen: boolean = false;
  preferencesComplete: boolean = false;
  coursesComplete: boolean = false;
  filtersComplete: boolean = false;
  routerEventSubscription: Subscription;
  navigationSubscription: Subscription;
  statusSubscription: Subscription;
  statusOverrideSubscription: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private questionnaireService: QuestionnaireService,
    private courseService: CourseService,
    private localisation: LocalisationService,
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.locale = this.localisation.getTranslationsForComponent('MainNavComponent');
    this.routerEventSubscription = this.router.events
      .filter(event => event instanceof NavigationStart)
      .subscribe((event: NavigationStart) => {
        this.getStatus();
      });

    this.getStatus();
    this.courseAreasSeen = sessionStorage.getItem('areas-seen') === 'true';

    this.filtersComplete = this.navigationService.defaultFiltersComplete;
    this.navigationSubscription = this.navigationService.filtersComplete.subscribe(value => {
      this.filtersComplete = value;
    });

    this.statusOverrideSubscription = this.questionnaireService.statusOverride.subscribe(status => {
      if (status !== null) {
        this.enableDisableItems(status);
      } else {
        this.getStatus();
      }
    });
  }

  ngOnDestroy(): void {
    this.routerEventSubscription.unsubscribe();
    this.navigationSubscription.unsubscribe();
    this.statusSubscription.unsubscribe();
    this.statusOverrideSubscription.unsubscribe();
  }

  getStatus() {
    if (this.authService.isAuthenticated()) {
      this.statusSubscription = this.questionnaireService
        .getQuestionnaireStatus()
        .subscribe(statusResponse => {
          this.enableDisableItems(statusResponse.status);
        });
    }
  }

  enableDisableItems(status: number) {
    this.questionnaireComplete = status >= 100;
    this.courseAreasComplete = status >= 300;
    this.preferencesComplete = status >= 400;
    this.coursesComplete = status >= 500;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_shared/main-nav/main-nav.component.ts